<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col>
        <transition name="fade">
          <b-card
            border-variant="info"
            header-bg-variant="primary"
            header-text-variant="white"
          >
            <div slot="header">
              <span data-font="20">Promotions</span>
              <div class="card-header-actions">
                <b-link
                  class="card-header-action btn-minimize"
                  v-b-toggle.collapse1
                >
                  <i class="icon-arrow-up text-white mt-1" data-font="20"></i>
                </b-link>
              </div>
            </div>
            <b-collapse id="collapse1" visible>
              <!-- <b-row>
                <b-col md="4" class="my-1">
                  <b-form-group label-cols-sm="3" class="mb-0">
                    <b-input-group>
                      <b-form-input v-model="filter" placeholder="Type to Search" />
                      <b-input-group-append>
                        <b-button
                          :disabled="!filter"
                          @click="filter = ''"
                          variant="btn btn-primary"
                        >Clear</b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col md="2" class="my-1">
                  <b-form-group label-cols-sm="3" class="mb-0">
                    <b-form-select :options="pageOptions" v-model="perPage" />
                  </b-form-group>
                </b-col>
                <b-col md="4" class="my-1">
                  <b-form-group label-cols-sm="3" class="mb-0">
                    <b-form-select
                      placeholder="Select Product Catalog"
                      :options="catalogList"
                      v-model="catalogSelectedID"
                      @change="catalogNameChange"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="2" class="my-1" v-if="catalogSelectedID!=1">
                  <router-link :to="`item/create/${catalogSelectedID}`">
                    <button class="mr-1 btn btn-primary" variant="facebook">
                      <i class="fa fa-plus"></i>
                      <span>Create</span>
                    </button>
                  </router-link>
                </b-col>
              </b-row>-->

              <b-table
                id="table-transition-example"
                :dark="dark"
                :hover="hover"
                :striped="striped"
                :bordered="bordered"
                :small="small"
                :fixed="fixed"
                responsive="sm"
                :items="items"
                :fields="captions"
                :current-page="currentPage"
                :per-page="perPage"
                :filter="filter"
                v-if="catalogSelectedID != 1 && !loading"
                class="mt-2"
                thead-class="header"
                primary-key="_id"
                :tbody-transition-props="transProps"
              >
                <template slot="action" slot-scope="data">
                  <b-button
                    size="sm"
                    class="mr-2"
                    variant="primary"
                    @click="uploadInventory(data)"
                  >
                    <i class="fa fa-upload"></i>
                  </b-button>
                  <router-link
                    :to="{ name: 'Item', params: { id: data.item._id } }"
                  >
                    <b-button size="sm" class="mr-2" variant="primary">
                      <i class="fa fa-pencil edit"></i>
                    </b-button>
                  </router-link>
                  <b-button
                    size="sm"
                    class="mr-2"
                    variant="danger"
                    @click="deleteItem(data)"
                  >
                    <i class="fa fa-trash bin"></i>
                  </b-button>
                </template>
              </b-table>

              <b-row v-show="catalogSelectedID != 1 && items.length > 0">
                <b-col md="12">
                  <nav class="float-right">
                    <b-pagination
                      :total-rows="totalRows"
                      :per-page="perPage"
                      v-model="currentPage"
                      prev-text="Prev"
                      next-text="Next"
                      hide-goto-end-buttons
                    />
                  </nav>
                </b-col>
              </b-row>
              <b-row v-if="loading">
                <b-col md="6">
                  <atom-spinner
                    :animation-duration="1000"
                    :size="60"
                    color="#ff1d5e"
                    class="float-right my-4"
                  />
                </b-col>
              </b-row>
              <b-row v-if="!loading">
                <b-col md="12">
                  <b-alert
                    v-model="showDismissibleAlert"
                    variant="info"
                    dismissible
                    >Data Not Found</b-alert
                  >
                </b-col>
              </b-row>
            </b-collapse>
          </b-card>
        </transition>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import cTable from "../base/Table.vue";
import { mapState } from "vuex";
import { AtomSpinner } from "epic-spinners";
import VueNotifications from "vue-notifications";
import miniToastr from "mini-toastr";

export default {
  name: "ViewItem",
  components: {
    cTable,
    AtomSpinner,
  },
  data: () => {
    return {
      transProps: {
        name: "flip-list",
      },
      showDismissibleAlert: false,
      loading: false,
      items: [],
      catalogSelectedID: "1",
      provider: "",
      catalogList: [
        {
          text: "Select Catalog",
          value: "1",
        },
      ],
      fields: [],
      filter: "",
      caption: "Table",
      hover: true,
      striped: false,
      bordered: true,
      small: false,
      fixed: false,
      tableData: [],
      perPage: 5,
      pageOptions: [5, 10, 15, 20, 25, 30],
      currentPage: 1,
      dark: false,
    };
  },
  methods: {},
  mounted: async function () {
    this.provider = this.$store.getters["auth/getUserID"];
  },
  computed: {
    ...mapState("auth", ["permissions"]),
    totalRows() {
      return this.items.length;
    },
    captions() {
      return this.fields;
    },
  },
};
</script>

<style scoped>
.mymodalclass > div {
  margin-top: 45px !important;
}
.text-center {
  text-align: center !important;
}
[data-font="20"] {
  font-size: 20px;
}
.edit {
  color: #ffffff !important;
}
.bin {
  color: white !important;
}
</style>
<style>
table.table-bordered > tbody > tr {
  /* text-transform: capitalize; */
  text-align: center;
}
table#table-transition-example .flip-list-move {
  transition: transform 1s;
}
</style>
